export default "__VITE_ASSET__9381a495__"